import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { CoachSummary } from '@backrs_ui/grow-ui/src/redux/coachingDashboard/coachingDashboard.types';
import type { AdminCohortCoach } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';
import { personName } from '@backrs_ui/grow-ui/src/utils/personName';

import { cohortCoachLabel } from './cohortCoaches';

type CoachesView = Readonly<{
  cohortId: number;
  /** Null until the cohort read lands, and for a cohort that is gone. */
  cohortName: string | null;
  search: string;
  offerable: readonly CoachSummary[];
  attached: readonly AdminCohortCoach[];
  /** The coach a removal confirmation is standing on, if any. */
  pendingRemoval: AdminCohortCoach | null;
}>;

export const useAgentContext = ({
  cohortId,
  cohortName,
  search,
  offerable,
  attached,
  pendingRemoval,
}: CoachesView) => {
  useRegisterAgentContext(
    cohortName === null
      ? null
      : {
          kind: 'list',
          description: `Coaches available to add to the cohort ${cohortName}, alongside the ones already on it.`,
          data: {
            cohort_id: cohortId,
            search,
            offerable: offerable.map((coach) => ({
              id: coach.id,
              name: personName(coach),
            })),
            attached: attached.map((coach) => ({
              id: coach.id,
              name: cohortCoachLabel(coach),
            })),
            pending_removal: pendingRemoval === null ? null : cohortCoachLabel(pendingRemoval),
          },
        },
  );
};
